<template>
  <div>
    <div>
      <VerifyWithMessage v-if="currentVerifyMethod === 'message'" />
      <VerifyWithEmail v-if="currentVerifyMethod === 'email'" />
    </div>
    <div class="flex items-center justify-center gap-4">
      <span class="text-primary-main text-base cursor-pointer" @click="router.push('login')">返回登录</span>
      <span @click="currentVerifyMethod = currentVerifyMethod === 'message' ? 'email' : 'message'" class="text-primary-main text-base cursor-pointer">{{ currentVerifyMethod === 'message' ? '邮箱' : '手机' }}找回</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import VerifyWithMessage from '@/components/forget-page/verify-with-message.vue'
import VerifyWithEmail from '@/components/forget-page/verify-with-email.vue'

const router = useRouter()

const currentVerifyMethod = ref('message')
</script>
